import React from 'react';
import { View } from 'react-native-web';
import HugeSquareWithTextAndBtn from '../../AuxiliaryComponent/MixComponent/HugeSquareWithTextAndBtn';
import SelectKeyboardComponent from '../../AuxiliaryComponent/MixComponent/SelectKeyboardComponent';
import {
  o_i_lets_do_it,
  o_i_step_2_of_2,
  o_i_switch_to_bank_keyboard_and,
} from '../../../../utils/DictionaryManagementUtils';
import { getRef } from '../../../../utils/Utils';

//= ========================================================================
const SelectKeyboardAndroidFP = ({
  globJSON,
  simPlatform,
  slideshowRefs,
}) => (
  <View ref={getRef(slideshowRefs)}>
    <SelectKeyboardComponent
      globJSON={globJSON}
      simPlatform={simPlatform}
    />
    <HugeSquareWithTextAndBtn
      globJSON={globJSON}
      simPlatform={simPlatform}
      withOutParagraph
      BtnInputText={o_i_lets_do_it}
    />
  </View>
);

export default SelectKeyboardAndroidFP;
